<div [class]="layout.shell">
  <header [class]="layout.header">
    <div class="flex items-center gap-2">
      <mat-icon
        class="h-5! w-5! shrink-0 text-xl! leading-5!"
        [class]="iconClass"
        >{{ data.icon }}</mat-icon
      >
      <h2 class="min-w-0 flex-1 truncate text-lg! leading-5! font-semibold! text-neutral-800">{{ data.titleKey | translate }}</h2>
    </div>

    <!-- Names the record rather than describing the act: a manager must see what this is about. -->
    <p
      class="truncate pl-7 text-sm text-neutral-500"
      [matTooltip]="data.subject"
    >
      {{ data.subject }}
    </p>
  </header>

  <div [class]="layout.body">
    <guarantees-callout
      tone="warning"
      icon="info"
      >{{ data.warningKey | translate }}</guarantees-callout
    >

    <!-- Only where the act is reported on. A confirmation that takes no ground asks nothing further. -->
    @if (data.reason; as reasonConfig) {
      <fieldset class="flex flex-col gap-1.5">
        <legend class="pb-1 text-sm font-semibold text-neutral-700">{{ reasonConfig.labelKey | translate }}</legend>

        <guarantees-option-picker
          wrap
          maxHeight="max-h-56"
          [options]="reasons"
          [placeholder]="reasonConfig.placeholderKey | translate"
          [emptyMessage]="'guaranteeV2.message.reasonNoMatch' | translate"
          [value]="reason()"
          (valueChange)="reason.set($event)"
        ></guarantees-option-picker>

        @if (!reason()) {
          <span class="text-sm text-neutral-400">{{ reasonConfig.requiredKey | translate }}</span>
        }
      </fieldset>
    }
  </div>

  <footer [class]="layout.footer">
    <button
      class="inline-flex items-center rounded-full px-3 py-1.5 text-sm font-medium text-neutral-500 transition-colors duration-150 hover:bg-neutral-100 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none motion-reduce:transition-none"
      type="button"
      (click)="cancel()"
    >
      {{ "guaranteeV2.action.cancel" | translate }}
    </button>

    <button
      class="ml-auto inline-flex items-center gap-1 rounded-full px-3 py-1.5 text-sm font-semibold text-neutral-0 transition-colors duration-150 focus-visible:ring-2 focus-visible:ring-primary-500/40 focus-visible:outline-none disabled:opacity-40 motion-reduce:transition-none"
      type="button"
      [class]="confirmClass"
      [disabled]="!canConfirm()"
      [matTooltip]="canConfirm() || !data.reason ? '' : (data.reason.requiredKey | translate)"
      (click)="confirm()"
    >
      <mat-icon class="h-3.5! w-3.5! text-sm! leading-3.5!">{{ data.icon }}</mat-icon>
      {{ data.confirmKey | translate }}
    </button>
  </footer>
</div>
